import { WishListLineModel } from "@insite/client-framework/Types/ApiModels";
import ga from "@starter/Framework/Common/GoogleAnalytics";

const mapWishListLineModel = (
    wishListLine: WishListLineModel,
    options?: Toolkit.GoogleAnalytics.Options,
): Toolkit.GoogleAnalytics.Item => {
    const {
        brand,
        erpNumber,
        isActive,
        isDiscontinued,
        productId,
        shortDescription,
        pricing,
        qtyOrdered,
        unitOfMeasure,
    } = wishListLine;

    return {
        discontinued: isDiscontinued || undefined,
        inactive: !isActive || undefined,
        item_brand: brand?.name,
        item_id: erpNumber,
        item_name: shortDescription,
        quantity: qtyOrdered ?? 1,
        unit_of_measure: unitOfMeasure || undefined,
        ...(isActive && pricing
            ? {
                  ...ga.util.getItemDiscountParameters(pricing.unitListPrice, pricing.unitNetPrice),
                  price: ga.util.parseAmount(pricing.unitNetPrice),
              }
            : undefined),
        ...ga.map.productInfosOption(options, productId, !isActive),
        ...options?.itemData,
    };
};

export default mapWishListLineModel;
